import { WhatCategoryRatingPresenter } from '@/presentation/presenters/dashboard/whatCategoryRatingPresenter'
import { CategoryRatingViewModel } from '@/presentation/viewmodels/dashboard/categoryRatingViewModel'

export function useWhatCategoryRatingPresenter(
  presenter: WhatCategoryRatingPresenter = new WhatCategoryRatingPresenter(new CategoryRatingViewModel())
) {
  return {
    isLoading: presenter.isLoading,
    error: presenter.error,
    hasData: presenter.hasData,
    chartData: presenter.chartData,
    chartSeries: presenter.chartSeries,
    chartOptions: presenter.chartOptions,
    initChart: presenter.initChart.bind(presenter)
  }
}
